import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full py-20 md:py-24 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Majestic%20sunrise%20over%20traditional%20Chinese%20mountain%20landscape%20with%20layered%20misty%20peaks%20golden%20warm%20light%20flowing%20clouds%20ancient%20pine%20trees%20on%20cliffs%20serene%20inspirational%20atmosphere%20soft%20ethereal%20glow%20oriental%20landscape%20aesthetic&width=1800&height=700&seq=cta-bg-home&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/50"></div>

      <div className="relative z-10 w-full max-w-2xl mx-auto text-center px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
          开启高义白洁的修身之旅
        </h2>
        <p className="text-white/75 text-sm md:text-base leading-relaxed mb-8">
          在纷繁世界中坚守本心，以高洁品格立身处世。从今天开始，修身高义，涵养白洁。
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/category/xiuyang-fangfa"
            className="px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            探索修养方法
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-white/15 text-white border border-white/30 font-medium rounded-md hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}